/** AspectValidationContent — renders `aspect_validation` entries (an observation being validated). */
import React from 'react';
import { useTranslation } from 'localization';
import { TimelineEvent } from 'types/timeline';

interface Props {
  event: TimelineEvent;
}

const AspectValidationContent: React.FC<Props> = ({ event }) => {
  const { t } = useTranslation();
  const payload = (event.payload ?? {}) as { status?: string; note?: string };

  return (
    <div className="timeline-event-content">
      <span className="timeline-event-content__text">
        {t('timeline.eventContent.aspectValidated', { status: payload.status ?? '' })}
      </span>
      {payload.note ? <span className="timeline-event-content__text">{payload.note}</span> : null}
    </div>
  );
};

export default AspectValidationContent;
